/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Since_Two_MonthsInputs */

const en_us2_profile_editors_pain_since_two_months = /** @type {(inputs: Profile_Editors_Pain_Since_Two_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About 2 months ago`)
};

const pt_br2_profile_editors_pain_since_two_months = /** @type {(inputs: Profile_Editors_Pain_Since_Two_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há 2 meses`)
};

const es_419_profile_editors_pain_since_two_months = /** @type {(inputs: Profile_Editors_Pain_Since_Two_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hace unos 2 meses`)
};

const pt_pt2_profile_editors_pain_since_two_months = /** @type {(inputs: Profile_Editors_Pain_Since_Two_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há cerca de 2 meses`)
};

const fr_fr2_profile_editors_pain_since_two_months = /** @type {(inputs: Profile_Editors_Pain_Since_Two_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Environ 2 mois`)
};

const de_de2_profile_editors_pain_since_two_months = /** @type {(inputs: Profile_Editors_Pain_Since_Two_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seit etwa 2 Monaten`)
};

const it_it2_profile_editors_pain_since_two_months = /** @type {(inputs: Profile_Editors_Pain_Since_Two_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da circa 2 mesi`)
};

/**
* | output |
* | --- |
* | "About 2 months ago" |
*
* @param {Profile_Editors_Pain_Since_Two_MonthsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_since_two_months = /** @type {((inputs?: Profile_Editors_Pain_Since_Two_MonthsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Since_Two_MonthsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_since_two_months(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_since_two_months(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_since_two_months(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_since_two_months(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_since_two_months(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_since_two_months(inputs)
	return en_us2_profile_editors_pain_since_two_months(inputs)
});
export { profile_editors_pain_since_two_months as "profile-editors.pain_since_two_months" }